import moment from 'moment';

export const DAYS = [
   'monday',
   'tuesday',
   'wednesday',
   'thursday',
   'friday',
   'saturday',
   'sunday'];

export const previousDay = (day) => {
    const index = DAYS.findIndex(d => d === day);
    if (index === -1) {
        return null;
    }
    return DAYS[(index - 1 + DAYS.length) % DAYS.length];
}

const isPeriodContinuousWithPreviousDay = (timePeriod,currentDayOfWeek,allAvailabilities) => {

    const previousDayAvailability = allAvailabilities.find(a => a.day_of_week === previousDay(currentDayOfWeek));
    if (!previousDayAvailability) {
        return false;
    }

    const previousDayLastPeriod = previousDayAvailability.time_periods?.[previousDayAvailability.time_periods.length - 1];

    if (!previousDayLastPeriod || !timePeriod) {
        return false;
    }

    return previousDayLastPeriod.end_time === '23:59' && timePeriod.start_time === '00:00';
}

export const getTimePeriodsOfADayFromAvailabilities = (day, availabilities) => {

    return availabilities
        .find(availability => availability.day_of_week === day.value)?.time_periods
        .map(timePeriod => {
            const [startHours, startMinutes] = timePeriod.start_time.split(':');
            const startDateTime = moment().set('hour', +startHours).set('minute', +startMinutes);

            const [endHours, endMinutes] = timePeriod.end_time.split(':');
            const endDateTime = moment().set('hour', +endHours).set('minute', +endMinutes);

            const isContinuousWithPreviousDay = isPeriodContinuousWithPreviousDay(timePeriod, day.value, availabilities);

            return {
                ...timePeriod,
                maxStartTime: moment(endDateTime).subtract(60, 'minutes'),
                minEndTime: isContinuousWithPreviousDay ? moment(startDateTime).add(15, 'minutes') : moment(startDateTime).add(60, 'minutes'),
            }
        }) || []
}
